import React from "react";

const FooterDash = () => {
  return (
    <React.Fragment>
      <footer className="w-full bg-black p-4 shadow md:flex md:items-center md:justify-between md:p-6 dark:bg-gray-800">
        <span className="text-sm text-white sm:text-center dark:text-gray-400">
          Copyright © 2022 Yoga Rizky Putra All Rights Reserved.
        </span>
      </footer>
    </React.Fragment>
  );
};

export default FooterDash;
